import React, {Component} from 'react';
import './PrintBoardEstimate.css';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import calIconYellow from '../../../../assets/img/calculator.png';
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import {BASE_URL} from "../../../../configuration";

class PrintBoardEstimate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quotation: {
                orderType: 1,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails : 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe : 1,
                    castellatedHoles : 0,
                    silkColor : 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            }
        };

        this.toPcbQuotationHomePage = this.toPcbQuotationHomePage.bind(this);
    }

    toPcbQuotationHomePage = (event) => {

        localStorage.setItem("type", 1);
        localStorage.setItem("type1q", JSON.stringify(this.state.quotation));

    };

    render() {
        return (
            <div className="row">
                <div className="homepage-heading">
                    <FormattedMessage id="app.home-content.pritboard.heading-new"
                                      defaultMessage="That idea of you will change the world!!"
                                      description=""/>
                </div>
                {/*<div className="print-board-estimate-caption">
                    <FormattedMessage id="app.home-content.pritboard.caption"
                                      defaultMessage="First, try estimate"
                                      description=""/>
                </div>*/}

                <div className="quotation-button-div">
                    <Link to="quotation/pcb">
                    <a onClick={this.toPcbQuotationHomePage}>
                        <button className="quotation-button">
                           <img src={calIconYellow} className="cal-icon-yll-1"/>&nbsp;
                            <FormattedMessage id="app.home-content.pritboard.btn-caption-new"
                                              defaultMessage="The world's largest prototype board factory"
                                              description=""/>

                        </button>
                    </a>
                    </Link>
                </div>

            </div>
        );
    }

}

export default PrintBoardEstimate;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/PrintBoardEstimate/PrintBoardEstimate.js